<div class="image-uploader">
    <input #input class="uploader" type="file" (change)="update($event)" accept="image/*" *ngIf="!url">
    <div class="preview" *ngIf="url">
        <img [src]="url" alt="" class="preview-image">
        <button mat-icon-button class="delete-button" (click)="delete()">
            <mat-icon> delete </mat-icon>
        </button>
    </div>
</div>
